export enum FormalyStatus {
  Form161FormalyStatus_Draft = 1,
  Form161FormalyStatus_OrderedAndWaitingForDataCompletition = 2,
  Form161FormalyStatus_SentToFormaly = 3,
  Form161FormalyStatus_Finished = 4,
  Form161FormalyStatus_Failed = 9,
}

export class Form161Filter {
  CustomerIdentityNumber: string;
  Employees: string[];
}

export class Form161Header {
  FormId: number;
  TofesId: number;
  StartDate: Date;
  StatusDate: Date;
  UpdateUserId: string;
  UpdateDate: Date;
  CustomerIdentityNumber: string;
  CustomerName: string;
  TikNikuim: string;
  CustomerCityName: string;
  CustomerAddress: string;
  CustomerAddressBuilding: string;
  CustomerContactPhone: string;
  CustomerContactCellPhone: string;
  CustomerContactMail: string;
  CustomerSignIdentityNumber: string;
  CustomerSignFirstName: string;
  CustomerSignLastName: string;
  CustomerSignCellPhone: string;
  CustomerSignPhone: string;
  CustomerSignMail: string;
  CustomerZipCode: string;
  CustomerDataValidated: boolean;
  CustomerMinimumDaysForEmployee: number;

  Employees: Form161Employee[];

  isChecked: boolean;
  CustomerAccountManagerEmail: string;

  AllEmployeesInStatusDraft: boolean;
}

export class Form161Employee {
  RecordId: number;
  EmployeeTofesId: string;
  EmployeeIdentityNumber: string;
  EmployeeFirstName: string;
  EmployeeLastName: string;
  FormStatusId: number;
  EmployeeCityName: string;
  EmployeeZipCode: string;
  EmployeeAddress: string;
  EmployeeBuilding: string;
  EmployeeCellPhone: string;
  EmployeeMail: string;
  EmployeeBirthDate: Date;
  WorkPeriodStart: Date;
  WorkPeriodEnd: Date;
  Sallary: number;
  LastSallary: number;
  SallaryHovatPizuim: number;
  RetirementReasonId?: number;
  isOwner: boolean;
  isOwnerRelated: boolean;
  OwnerRelation: string;
  isEntitledToBudgetPension: boolean;
  EntitledToBudgetPensionFromDate: Date;
  EntitledToBudgetPensionSallary: number;
  isRetirementGrantPayment: boolean;
  isCompletionCompensation: boolean;
  CompletionCompensationHow: string;
  CompletionCompensationPayingType: string;
  CompletionCompensationPayingName: string;
  CompletionCompensationPayingCode: string;
  CompletionCompensationTikNikuim: string;
  CompletionCompensationAmount: number;
  CompletionCompensationPaymentDate: Date;
  CompletionCompensationHow2: string;
  CompletionCompensationPayingType2: string;
  CompletionCompensationPayingName2: string;
  CompletionCompensationPayingCode2: string;
  CompletionCompensationTikNikuim2: string;
  CompletionCompensationAmount2: number;
  CompletionCompensationPaymentDate2: Date;
  isContinuouslyWork: boolean;
  isTaxCompensationRelevant: boolean;
  isPart10aChecked: boolean;
  isPart11aChecked: boolean;
  FundInstitutions: Form161EmployeeFundInstitution[];
  ContinuouslyWorks: Form161EmployeeContinuouslyWork[];
  RetirementGrantPayments: Form161EmployeeRetirementGrantPayment[];
  isChecked: boolean;
  FormalySendDate: Date;
  FormalyResponse: string;
  SignatureStatus: string;
  FormalyRequestTreatmentStatus: string;
  FormalyFileReceived: boolean;
  FormalyStatusUpdateDate: Date;
}

export class Form161EmployeeFundInstitution {
  RecordFundInstitutionId: number;
  FundInstitutionId: number;
  Name: string;
  IncomeTaxAuthorizationNumber: number;
  InstitutionName: string;
  IdentityNumber: string;
  PayingName: string;
  TikNikuim: string;
  PayingCode: string;
  PayingType: string;
  FirstPaymentDate: Date;
  LastPaymentDate: Date;
  AmountAtRetirement9a: number;
  AdditionalAccumulation9a: number;
  TotalAmount: number;
  isPaymentsWithTaxes: boolean;
  PaymentsWithTaxes: number;
  PaymentsWithTaxesIncludeProfit: number;
  is11a: boolean;
  AmountAtRetirement11a: number;
  AdditionalAccumulation11a: number;
  isChecked: boolean;
}

export class Form161EmployeeContinuouslyWork {
  ContinuouslyWorkId?: number;
  PeriodFrom: Date;
  PeriodTo: Date;
  Sallary: number;
  PositionPercent: number;
}

export class Form161EmployeeRetirementGrantPayment {
  RetirementGrantPaymentId?: number;
  PaymentDate: Date;
  Payment: number;
}

export class Form161SaveContainer {
  form161Header: Form161Header;
  form161EmployeeActual: Form161Employee;
  actionType: string;
  employeeStatusIdActual: number;
  customerDataIsValid: boolean;
}

export class Form161EmployeeData {
  RecordId: number;
  FormId: number;
  EmployeeIdentityNumber: string;
  EmployeeFirstName: string;
  EmployeeLastName: string;
  StartDate: Date;
  StatusName: string;
  FormStatusId: number;
  SignatureStatus: string;
  FormalyRequestTreatmentStatus: string;
  FormalyFileReceived: boolean;
  FormalyStatusUpdateDate: Date;
}



// WEBPACK FOOTER //
// C:/ProjectsOnGit/USilence/USilence/Client/src/app/model/form161Formaly.model.ts